import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../api';

export const login = createAsyncThunk('auth/login', async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post('token', data);
    return response;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error.response);
  }
});

export const getLoggedInUser = createAsyncThunk('auth/loggedInUser', async (data, { rejectWithValue }) => {
  try {
    const response = await axios.get('/users/me/');
    return response;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error.response);
  }
});

export const getHomeData = createAsyncThunk('auth/homeData', async (_, { rejectWithValue }) => {
  try {
    const response = await axios.post('/home/');
    return response;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error.response);
  }
});